<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" ref="searchForm" :model="filters" :size="size">
    <el-form-item class="select_btn_130" prop="myAuditStatus">
      <el-select
        class="select_btn_style"
        v-model="filters.myAuditStatus"
        placeholder="我的审核状态"
      >
        <el-option
          v-for="(item, i) in myAuditStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn_130" prop="auditStatus">
      <el-select
        class="select_btn_style"
        v-model="filters.auditStatus"
        placeholder="申报审核状态"
      >
        <el-option
          v-for="(item, i) in auditStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="deptName" class="text_input m-l-8">
      <el-input
        clearable
        placeholder="请选择工作单位"
        v-model="deptName"
        @focus="showDeptModal"
        @clear="clearDepts"
      >
      </el-input>
    </el-form-item>
    <el-form-item label="讲座时间:">
      <el-date-picker
        v-model="lectureTime"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
      />
    </el-form-item>
    <el-form-item prop="nameOrTheme" class="text_input">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.nameOrTheme"
        placeholder="姓名/讲座主题"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
    <!--选择工作单位弹窗-->
    <SingleCheckTree 
      ref="deptTree" 
      :defaultCheckedKeys="defaultCheckedKeys"
      :showModal="deptDialog" 
      @deptSelected="selectDept"/>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { deptTreeNew } from "@/api/dept";
import { getSysParamByTypes } from "@/api/sysParam";
import SingleCheckTree from "../../components/tree/singleCheckTree.vue";

export default {
  name: "search",
  components: {
    butn,
    SingleCheckTree
  },
  data() {
    return {
      size: "small",
      filters: {
      },
      lectureTime: null,
      auditStatusList: [],
      myAuditStatusList: [],
      deptName: "",
      defaultCheckedKeys: [],
      deptDialog: {
        flag: false,
      },
    };
  },
  created() {
    const emptyObj = Object.create(null);
    this.filters = emptyObj;
    this.getSysParamByTypes(["TOPICLECTURE_AUDIT", "MY_AUDIT_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["TOPICLECTURE_AUDIT"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["MY_AUDIT_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.auditStatusList = res.data["TOPICLECTURE_AUDIT"] || [];
        this.myAuditStatusList = res.data["MY_AUDIT_STATUS"] || [];
      });
    },
    initData() {
      //查询
      if (this.lectureTime && this.lectureTime.length != 0) {
        this.filters.lectureStartTime = this.lectureTime[0];
        this.filters.lectureEndTime = this.lectureTime[1];
      } else {
        this.filters.lectureStartTime = "";
        this.filters.lectureEndTime = "";
      }
      let params = {
        ...this.filters,
      };
      this.$emit("search", { ...params });
    },
    resetData() {
      //重置
      this.deptName = "";
      this.lectureTime = null;
      this.$refs.searchForm.resetFields();
      this.clearDepts();
      this.$emit("search");
    },
    showDeptModal() {
      this.deptDialog.flag = true;
    },

    // 工作单位选择确定
    selectDept(dept) {
      this.deptName = dept.deptName;
      this.filters.deptLevelCodeQuery = dept.deptLevelCode;
      this.defaultCheckedKeys = [dept.uuid];
      this.deptDialog.flag = false;
    },

    clearDepts() {
      this.defaultCheckedKeys = [];
      this.filters.deptLevelCodeQuery = "";
      this.$nextTick(()=> {
        this.$refs.deptTree.$refs["deptTree"]?.setCheckedKeys(this.defaultCheckedKeys);
      })
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-date-editor {
  width: 250px;
}
/deep/.el-range-input {
  width: 85px;
}
.text_input {
  /deep/.el-input {
    width: 180px;
    .el-input__inner {
      padding-right: 0 !important;
    }
  }
}
.select_btn_160 {
  width: 110px;
  /deep/.select_btn_style {
    margin-left: -12px;
  }
  /deep/.el-input__inner {
    width: 110px;
  }
}
</style>
